export const SOURCE = {
  COMPANY_GROUP: "COMPANY_GROUP",
  RESOLVED_TICKETS: "RESOLVED_TICKETS",
  UNRESOLVED_TICKETS: "UNRESOLVED_TICKETS",
  ALL_FILINGS: "ALL_FILINGS",
} as const;

export type SourceType = (typeof SOURCE)[keyof typeof SOURCE];

export const NOTE_TAB = {
  ALL: "ALL",
  CURRENT: "CURRENT",
  ARCHIVED: "ARCHIVED",
} as const;

export type NoteTabType = (typeof NOTE_TAB)[keyof typeof NOTE_TAB];

export const NOTE_TYPE = {
  TASK: "TASK",
  TICKETS: "TICKETS",
  GROUP: "GROUP",
} as const;

export type NoteType = (typeof NOTE_TYPE)[keyof typeof NOTE_TYPE];

export const MENTION_BLOT_NAME = "mention";

export const MENTION_LIST_CONTAINER_CLASS = "ql-mention-list-container";
